import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { PostPutOrderCancellationPolicyRequestAdmin } from '@/backend/market'
import { CreateUpdateOrderCancellationPolicyEntity } from '../../domain/entities/CreateUpdateOrderCancellationPolicyEntity'

export class CreateUpdateOrderCancellationPolicyModel extends CreateUpdateOrderCancellationPolicyEntity {
  constructor(dataDto: CreateUpdateOrderCancellationPolicyEntity) {
    super()
    mapEntityProperties<PostPutOrderCancellationPolicyRequestAdmin>(this, dataDto)
  }
}
